import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import axios from "axios";
import { URL } from "../src/constant";
import Cookies from "js-cookie";
import { ThemeProvider } from "@emotion/react";
import { BrowserRouter } from "react-router-dom";
import { createTheme, CssBaseline } from "@mui/material";

axios.defaults.baseURL = URL;
axios.defaults.withCredentials = true;
// axios.defaults.headers = { Authorization: Cookies.get("UserAuthorization") };
const defaultTheme = createTheme();


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={defaultTheme}>
      <BrowserRouter>
        <CssBaseline />
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
